import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';
import FileUpload from 'ui-component/FileUpload';
import { getCurrencySymbolV2, numberFormatter } from 'utils/currency';
import Select from 'react-select';
import { toast } from 'react-hot-toast';
import InputGroup from 'react-bootstrap/InputGroup';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import ReactSelect from 'react-select';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import { useDropzone } from 'react-dropzone';

import { ChevronLeftIcon, PlusIcon, InfoIcon } from 'ui-component/custom-icons/icons';



function PaymentFormModal({ showPaymentModal, editPayment, handleClose, onFormSubmit, estimate, defaultPaymentType, selectedPaymentDetails, source }) {
    const [disableStatus, setDisablestatus] = useState(false);
    const [imageId, setImageId] = useState(null);
    const [files, setFiles] = useState([]);
    const [selectedPaymentType, setSelectedPaymentType] = useState('Bank Transfer');
    const [selectedCreditNoteId, setSelectedCreditNoteId] = useState(null);
    const [transitCompanyCreditNotes, setTransitCompanyCreditNotes] = useState([]);
    const [creditNoteLists, setCreditNoteLists] = useState([]);
    const [remainingBalance, setRemainingBalance] = useState(0);
    const [remainingCredit, setRemainingCredit] = useState(0);
    const [amountToPay, setAmountToPay] = useState(0);
    const [allowInvoiceSettlement, setAllowInvoiceSettlement] = useState(false);
    const [optionSelected, setOptionSelected] = useState(false);
    const [totalOpen, setTotalOpen] = useState(0);
    const [convertedTotalOpen, setConvertedTotalOpen] = useState(0);
    const [defaultCurrency, setDefaultCurrency] = useState('USD($)');
    const [selectedCurrency, setSelectedCurrency] = useState('');
    const [selectedCreditNote, setSelectedCreditNote] = useState(null);
    const [hasAttachment, setHasAttachment] = useState(false);
    const [uploadedFileName, setUploadedFileName] = useState('');
    const [uploadedFileSize, setUploadedFileSize] = useState('');
    const [uploadedFileExtension, setUploadedFileExtension] = useState('');
    const [isAttachmentLoading, setIsAttachmentLoading] = useState(false);

    const bankPaymentTypes = [
        { label: 'Bank Transfer', value: 'Bank Transfer' },
        { label: 'Bank Charges', value: 'Bank Charges' },
        { label: 'Credit Card', value: 'Credit Card' },
        { label: 'Bank Cheque', value: 'Bank Cheque' },
        { label: 'Cash', value: 'Cash' },
        { label: 'USDT', value: 'USDT' },
        { label: 'Credit Note', value: 'Credit Note' },
    ];

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        watch
    } = useForm();

    const handlePayFileOnChange = (e) => {
        if (e.target.files) {
            setPaymentFile(e.target.files[0]);
        }
    };

    const currencies = [
        { label: 'USD($)', value: 'usd' },
        { label: 'EUR(€)', value: 'eur' },
        { label: 'AED(Ð)', value: 'aed' }
    ];     

    const formatOptionLabel = ({ label, value }) => (
        <div dangerouslySetInnerHTML={{ __html: label }} />
    );


    useEffect(() => {
        
        const id = estimate?.transit_company_id || estimate?.customer_id;
		api.getSelectOptionsListWithId('get_available_credit_notes_by_invoice', id).then((res) => {
            if (res?.status) {
                const tempList = res.data.map((item) => ({
                    ...item,
                    label: `${item.option_label_name}`,
                    value: item.id,
                }));
                setCreditNoteLists(tempList);
            }
		});
        
    }, [])
    
    useEffect(() => {
        if (estimate?.customer?.credit_notes?.length > 0) {

            estimate?.customer?.credit_notes?.map((credit) => {
                if (credit?.remaining_credit > 0) {
                    setAllowInvoiceSettlement(true);
                    setTransitCompanyCreditNotes((prev) => [
                        ...prev,
                        {
                            label: `<div class="font500">🔴 Credit Note ${credit?.invoice_number} ${credit?.customer?.name
                                ? ('<span style="margin-left: 5px; margin-right: 5px">•</span> ' + credit?.customer?.name + '')
                                : ''} <span style="margin-left: 5px; margin-right: 5px">•</span> ${estimate?.customer?.name}</div> <div>${credit?.start_date} <span style="margin-left: 5px; margin-right: 5px">•</span> ${credit?.currency} ${credit?.remaining_credit}</div><div>${credit?.estimation_details?.map((item => item.details)).join(', ')}</div>`,
                            value: credit?.id,
                            remainingCredit: credit?.remaining_credit
                        }
                    ]);
                }
            });
        }
        
        reset({
            // paymentType: editPayment?.pay_type || 'Bank Transfer',
            paymentAmount: editPayment?.amount_paid || 0,
            paymentDate: editPayment?.payment_date ? moment(editPayment?.payment_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        });
        setImageId(editPayment?.payment_attachment?.id || null);
        setTotalOpen(estimate?.open_balance?.open);
        setConvertedTotalOpen(estimate?.converted_currency_open_balance[estimate?.currency])

        if (estimate?.currency === 'eur') {
            setDefaultCurrency('EUR(€)');
        } else if (estimate?.currency === 'usd') {
            setDefaultCurrency('USD($)');
        } else if (estimate?.currency === 'aed') {
            setDefaultCurrency('AED(Ð)');
        } else {
            setDefaultCurrency('USD($)');
        }
        setSelectedCurrency(estimate?.currency);
        

    }, [showPaymentModal, editPayment]);

    useEffect(() => {
        
        const subscription = watch((value, { name, type, currency }) => {
            
            if (name == 'paymentAmount' && type == 'change') {
                calculateNewOpen(value?.paymentAmount, selectedCurrency);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, selectedCurrency]);

    useEffect(() => {
        if (defaultPaymentType != null) {
            setSelectedPaymentType(defaultPaymentType)
        } else {
            setSelectedPaymentType('Bank Transfer')
        }
        if (selectedPaymentDetails != null) {
            setAmountToPay(selectedPaymentDetails?.amount_paid);
            setTotalOpen(Number(estimate?.open_balance?.open) + Number(selectedPaymentDetails?.amount_paid));
            setConvertedTotalOpen(Number(estimate?.converted_currency_open_balance[selectedCurrency]) + Number(selectedPaymentDetails?.amount_paid));
        } else {
            setSelectedPaymentType('Bank Transfer')
        }
    }, [defaultPaymentType, selectedPaymentDetails])

    const calculateNewOpen = (paid, currency) => {
        setAmountToPay(paid)
        if (editPayment) {
            setTotalOpen(Number(estimate?.open_balance?.open) + Number(editPayment?.amount_paid) - Number(paid));
            setConvertedTotalOpen(Number(estimate?.converted_currency_open_balance[currency]) + Number(editPayment?.amount_paid) - Number(paid));
        } else {
            setTotalOpen(Number(estimate?.open_balance?.open) - Number(paid));
            setConvertedTotalOpen(Number(estimate?.converted_currency_open_balance[currency]) - Number(paid));
        }
    };

    const handleOnSubmit = (data) => {
        if (!selectedPaymentType) {
            toast.error('Payment Type is required');
            return false;
        }
        if (amountToPay === '0.00' || amountToPay === 0 || amountToPay === '') {
            toast.error('Amount is required');
            return false
        }
        onFormSubmit &&
            onFormSubmit({
                payment_type: selectedPaymentType,
                credit_note_id: selectedCreditNote?.id,
                payment_date: data?.paymentDate,
                // amount_paid: data?.paymentAmount,
                amount_paid: amountToPay,
                currency: selectedCurrency,
                estimation_attachment_id: imageId,
                payment_id: editPayment?.id || undefined
            });
    };

    const handleChangeCurrency = (currency) => {
        setConvertedTotalOpen(estimate?.converted_currency_open_balance[currency?.value])
        setDefaultCurrency(currency.label);
        setSelectedCurrency(currency?.value);
    }

    const handleCreditChange = (e) => {
        setSelectedCreditNote(e);
        setAmountToPay(e?.amount);
        setSelectedCurrency(e?.currency);
        
        // setPaymentDetails({ ...paymentDetails, amount: e?.amount, currency: e?.currency });
    }

    useEffect(() => { 
        if (estimate?.is_credit_note === 1) {
            const value = estimate?.converted_currency_open_balance?.[selectedCurrency] || 0;
            const computeOpenBalance = Math.abs(value) - amountToPay;
            setConvertedTotalOpen(computeOpenBalance)
        } else {
            const computeOpenBalance = estimate?.converted_currency_open_balance[selectedCurrency] - amountToPay;
            setConvertedTotalOpen(computeOpenBalance)
        }
    }, [selectedCurrency, amountToPay])
    



    const handleFileUpload = (e) => {
        const files = e.target.files;
        setFiles(files);
        setDisablestatus(true);
        if (files && files.length > 0) {
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                formData.append('payment_file', files[i]);
            }
            if (source === 'invoice') {
                formData.append('estimation_id', estimate?.id);
                api.addInvoicePaymentFile(formData).then((res) => {
                    setDisablestatus(false);
                    setImageId(res.data);
                });
            } else {
                formData.append('sales_order_id', estimate?.id);
                api.addSalesOrderPaymentFile(formData).then((res) => {
                    setDisablestatus(false);
                    setImageId(res.data);
                });
            }

        }
    };

    const uploadAttachment = async (attachment) => {
        
        setUploadedFileName(attachment.name);
        
        // setUploadedPaymentAttachment(attachment);
        let sizeStr = "";
        const sizeInKB = attachment.size / 1024;
        if (sizeInKB >= 1024) {
            const sizeInMB = sizeInKB / 1024;
            sizeStr = `${sizeInMB.toFixed(2)} MB`;
        } else {
            sizeStr = `${sizeInKB.toFixed(2)} KB`;
        }

        
        setUploadedFileExtension(attachment.type);
        setUploadedFileSize(sizeStr);
        try {
            setHasAttachment(true)
            setIsAttachmentLoading(true)


            const formData = new FormData();
            // for (let i = 0; i < files.length; i++) {
            //     formData.append('payment_file', files[i]);
            // }
            formData.append('payment_file', attachment);

            formData.append('estimation_id', estimate?.id);
            api.addInvoicePaymentFile(formData).then((res) => {
                setDisablestatus(false);
                setImageId(res.data);
                setIsAttachmentLoading(false)
                toast.success('File uploaded successfully');
            });

            // setTimeout(() => {
            //     setIsAttachmentLoading(false)
            //     toast.success('File uploaded successfully');
            // }, 2000);
            
            
        } catch (error) {
            console.error('Error uploading file:', error);
            toast.error('Error uploading file');
        }
    };
    
    const handleRemoveAttachment = async () => {

        setUploadedFileExtension('');
        setHasAttachment(false);
        setUploadedFileName('');
        setUploadedFileSize('');
        // toast.success('File deleted successfully');
        
        api.deleteSalesInvoiceAttachment(imageId).then((res) => {
            setImageId(null);
        });
    }



    
    

    const allowedExtensions = ['pdf', 'jpeg', 'jpg', 'png'];
    const validateFileExtension = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        return allowedExtensions.includes(extension);
    };
    
    const onAttachmentDrop = useCallback((acceptedFiles) => {

        const file = acceptedFiles[0];
        if (!file) return;
        if (!validateFileExtension(file.name)) {
            toast.error('Invalid file extension. Please select a PDF, JPEG, JPG, or PNG file.');
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            toast.error('File size should not exceed more than 5MB.');
            return;
        }
        let sizeStr = '';
        if (file.size >= 1024 * 1024) {
            sizeStr = (file.size / (1024 * 1024)).toFixed(2) + ' MB';
        } else {
            sizeStr = (file.size / 1024).toFixed(2) + ' KB';
        }

        uploadAttachment(acceptedFiles[0]);
        setPaymentData((prevData) => ({ ...prevData, attachment: acceptedFiles[0] }));


        // if (validateFileExtension(acceptedFiles[0].name)) {
        //     uploadAttachment(acceptedFiles[0]);
        // 	setPaymentData((prevData) => ({ ...prevData, attachment: acceptedFiles[0] }));
        // } else {
        // 	toast.error('Invalid file extension. Please select a PDF, JPEG, JPG, or PNG file.');
        // }
    }, []);
    
    const { getRootProps: getAttachmentRootProps, getInputProps: getAttachmentInputProps } = useDropzone({ onDrop: onAttachmentDrop });



    return (
        <Modal show={showPaymentModal} onHide={handleClose} centered size="md">
            <Modal.Body>
                <div className="" style={{ padding: '10px' }}>
                    <form onSubmit={handleSubmit(handleOnSubmit)}>

                        <div >
                            <div className="" style={{ marginBottom: '20px' }}>

                                <div className="row">
                                    <div className="col-12">
                                        <div className="d-flex justify-content-center">
                                            <h2 className="h4 mb-0 font-weight-bold">Register payment</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="row" style={{ marginTop: '15px' }}>
                                    <div className="col-12 text-center">
                                        You are going to settle an amount for {source === 'invoice' ? 'Invoice ' : 'Sales Order '}
                                        <span className='text-primary font500'>{estimate?.invoice_number ?? estimate?.estimation_number}</span>.
                                    </div>
                                </div>
                            </div>
                            <div className="row m-0">
                                <div className="form-group col-md-6">
                                    <label htmlFor="paymentType">Payment Type</label>
                                    {/* <input type="text" className="form-control" value={selectedPaymentType} id="paymentType" readOnly /> */}

                                    <Select
                                        menuPosition={'fixed'}
                                        options={bankPaymentTypes}
                                        value={bankPaymentTypes?.find((y) => y?.value == selectedPaymentType)}
                                        className="rs-container"
                                        classNamePrefix="rs"
                                        placeholder="Select or type..."
                                        onChange={(e) => {
                                            setSelectedPaymentType(e?.value);
                                        }}
                                    />

                                    {errors.paymentType && <p className="mt-1 text-danger">Payment Type is required</p>}
                                </div>
                                <div className="form-group col-md-6">
                                    <label htmlFor="paymentAmount">Date</label>
                                    <input type="date" className="form-control" id="paymentDate" {...register('paymentDate', { required: true })} />
                                    {errors.paymentDate && <p className="mt-1 text-danger">Invalid Date</p>}
                                </div>
                                {
                                    selectedPaymentType === 'Credit Note' && (
                                        <>
                                            <div className="form-group col-md-12">
                                                <label htmlFor="paymentType">Available Credit Note</label>

                                                <ReactSelect
                                                    className="rs-container"
                                                    classNamePrefix="rs"
                                                    options={[...creditNoteLists]?.map((m) => ({
                                                        ...m,
                                                        optionAttribute: m.attribute,
                                                    }))}
                                                    // value={models?.find((v) => v?.value == item.model)}
                                                    menuPlacement="auto"
                                                    menuPosition="fixed"
                                                    placeholder="Select or type..."
                                                    formatOptionLabel={({ label, optionAttribute }) => (
                                                        <div dangerouslySetInnerHTML={{ __html: label }}></div>
                                                    )}
                                                    onChange={(e) => {
                                                        handleCreditChange(e);
                                                    }}
                                                    styles={{
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            // width: '800px', // Adjust the width as needed
                                                            // marginLeft: '-73px',
                                                            // height: '370px', // Set the maximum height of the dropdown box
                                                            overflowY: 'auto', // Enable vertical scrolling
                                                        }),
                                                        option: (provided, { selectProps, data }) => {
                                                            // Find the index of the current option
                                                            const index = selectProps.options.findIndex(option => option.value === data.value);
                                                            return {
                                                            ...provided,
                                                            marginBottom: '5px', // Existing space between options
                                                            marginTop: index === 0 ? '10px' : 0, // Add more spacing on top of the first option
                                                            };
                                                        },
                                                    }}
                                                />

                                                {errors.invoice && <p className="mt-1 text-danger">Invoice is required</p>}
                                            </div>
                                        </>
                                    )
                                }
                                <div className="form-group col-md-6">
                                    <label htmlFor="paymentAmount">Amount </label>
                                    <div className="custom-input-group payment-input-group">
                            
                                        {
                                            selectedPaymentType === 'Credit Note' ? (
                                                <div className=" d-flex input-group-2-form input-group-2-form-currency">
        
                                                    <input
                                                        type="text"
                                                        className="form-control left-input"
                                                        id="inputName"
                                                        value={selectedCreditNote?.currency_label}
                                                        disabled={true}
                                                        style={{ width: '75px' }}
                                                    />
                                                    <input
                                                        type="number"
                                                        className="form-control right-input"
                                                        // id="paymentAmount" {...register('paymentAmount', { required: true, min: 1 })}
                                                        value={amountToPay}
                                                        onFocus={(event) => {
                                                            if (event.target.value == '0.00' || event.target.value == '0') {
                                                                setAmountToPay('');
                                                            }
                                                            event.target.select();
                                                        }}
                                                        autoComplete={'off'}
                                                        onClick={(e) => {
                                                            if (e.target.value === '0' || e.target.value === '0.00') {
                                                                setAmountToPay('');
                                                            }
                                                        }}
                                                        onBlur={(e) => {
                                                            if (e.target.value === '' || e.target.value === '0' || e.target.value === '0.00') {
                                                                setAmountToPay('0.00');
                                                                // setPaymentDetails({ ...paymentDetails, amount: '0.00' });
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            setAmountToPay(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <>
                                                        
                                                    <InputGroup className="mb-3 d-flex">
                                                        <DropdownButton
                                                            variant="outline-secondary"
                                                            title={defaultCurrency}
                                                            id="input-group-dropdown-1"
                                                        >
                                                            {
                                                                currencies.map((currency) => { 
                                                                    return (
                                                                        <Dropdown.Item
                                                                            href="#"
                                                                            key={currency.value}
                                                                            onClick={() => { 
                                                                                handleChangeCurrency(currency)
                                                                            }}
                                                                        >
                                                                            {currency.label}
                                                                        </Dropdown.Item>
                                                                    )
                                                                })
                                                            }
                                                        </DropdownButton>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            // id="paymentAmount" {...register('paymentAmount', { required: true, min: 1 })}
                                                            value={amountToPay}
                                                            onFocus={(event) => {
                                                                if (event.target.value == '0.00' || event.target.value == '0') {
                                                                    setAmountToPay('');
                                                                }
                                                                event.target.select();
                                                            }}
                                                            onChange={(e) => {
                                                                setAmountToPay(e.target.value);
                                                            }}
                                                            autoComplete={'off'}
                                                            autoFocus
                                                        />
                                                    </InputGroup>
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: '40%',
                                                            right: '13px',
                                                            zIndex: 3,
                                                        }}
                                                    >
                                                        <button
                                                            className="btn btn-primary-small-fit" 
                                                            onClick={() => {
                                                                setAmountToPay(convertedTotalOpen)
                                                            }}
                                                            style={{ 
                                                                padding: '5px 8px'
                                                            }}
                                                            type="button"
                                                        >
                                                            Full
                                                        </button>
                                                    </div>
                                                </>
                                            )
                                        }
                            
                                    </div>
                                    
                        
                                    {errors.paymentAmount && <p className="mt-1 text-danger">Invalid Amount</p>}
                                </div>
                                <div className="form-group col-md-6">
                                    <label htmlFor="paymentAmount">Open ({getCurrencySymbolV2(selectedCurrency)})</label>
                                    {/* <input type="text" className="form-control" value={numberFormatter.format(totalOpen)} readOnly /> */}
                                    <input
                                        type="text"
                                        className="form-control"
                                        // value={numberFormatter.format(totalOpen)}
                                        value={numberFormatter.format(convertedTotalOpen || 0)}
                                        readOnly
                                    />
                                </div>


                                {/* <div className="form-group col-md-12">
                                    <label htmlFor="shipmentTracking">Attachment</label>
                                    <FileUpload
                                        accept=".png,.jpg,.jpeg,.pdf"
                                        loading={disableStatus}
                                        onChange={(e) => {
                                            handleFileUpload(e);
                                        }}
                                        selectedValue={editPayment?.payment_attachment}
                                    />
                                </div> */}

                                <div className="form-group col-12">
                                    
                                    
                                    <div>
                                        {
                                            hasAttachment ? (
                                                <>
                                                    <div className="row m-0" style={{ padding: '0' }}>
                                                            <div className="col-12" style={{ padding: '0' }}>
                                                                <div
                                                                    className={`bg-white  w-100 border card-border-gray relative`}
                                                                    style={{
                                                                        borderRadius: '10px',
                                                                    }}
                                                                >
                                                                    <div style={{ padding: '0px 15px' }}>
                                                                        <div className="row">
                                                                            <div className="col-12">
                                                                                <div className="section-head row" style={{ padding: '0px 10px !important', paddingLeft: '0px' }}>
                                                                                    <div style={{ alignItems: 'center', fontSize: '14px' }} className="col-10">
                                                                                        <div className="flex align-items-center" style={{ gap: '10px' }}>
                                                                                            <div>
                                                                                                {uploadedFileExtension === 'application/pdf' ? (
                                                                                                    <PictureAsPdfOutlinedIcon style={{ fontSize: 24 }} />
                                                                                                ) : (
                                                                                                    <InsertPhotoOutlinedIcon style={{ fontSize: 24 }} />
                                                                                                )}
                                                                                            </div>
                                                                                            <div>
                                                                                                <div className="">
                                                                                                    {uploadedFileName}
                                                                                                </div>
                                                                                                <div className="text-gray-600" style={{ fontSize: '12px' }}>{uploadedFileSize}</div>
    
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="actions col-2 flex align-items-center justify-end" style={{ gap: '8px' }}>
                                                                                        
                                                                                        <div 
                                                                                            className="payment-modal-attachment-delete"
                                                                                            onClick={() => {
                                                                                                handleRemoveAttachment()
                                                                                            }}
                                                                                        >
                                                                                            <svg id="Component_127_1" height="12" width="12" data-name="Component 127 – 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.295 19.289">
                                                                                                <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
                                                                                            </svg>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    {
                                                                        isAttachmentLoading && (
                                                                            <div className="card-footer p-0 border-0 bg-transparent" style={{ height: '4px', marginTop: '-4px' }}>
                                                                                <div className="progress" style={{ height: '4px', borderRadius: '0', backgroundColor: 'transparent' }}>
                                                                                    <div 
                                                                                        className="progress-bar progress-bar-animated" 
                                                                                        role="progressbar" 
                                                                                        style={{ 
                                                                                            width: '100%', 
                                                                                            background: 'linear-gradient(90deg, #007bff 0%, #00d4ff 50%, #007bff 100%)',
                                                                                            backgroundSize: '200% 100%',
                                                                                            animation: 'loading-slide 2s infinite linear'
                                                                                        }}
                                                                                    ></div>
                                                                                </div>
                                                                            </div>
    
                                                                        )
                                                                    }
    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    {/* <div className="payment-modal-attachment-container">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <div className="row">
                                                                    <div className="col-12" style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <div className="payment-modal-attachment-icon">
                                                                            <FaPaperclip />
                                                                        </div>
                                                                        <div className="payment-modal-attachment-name">
                                                                            <div>{uploadedFileName}</div>
                                                                            <div>{uploadedFileSize}</div>
                                                                            
                                                                        </div>
                                                                        <div 
                                                                            className="payment-modal-attachment-delete"
                                                                            onClick={() => {
                                                                                handleRemoveAttachment()
                                                                            }}
                                                                        >
                                                                            <svg id="Component_127_1" height="12" width="12" data-name="Component 127 – 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.295 19.289">
                                                                                <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        isAttachmentLoading && (
                                                                            <div className="col-12">
                                                                                <div className="animated-progress-bar"></div>
                                                                            </div>
    
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </>
                                            ) : (
                                                <div {...getAttachmentRootProps()}>
        
                                                    {/* <div
                                                        className="add-item-empty-div"
                                                    >
                                                        <button type="button" className="btn btn-primary btn-outlined-main-primary dragText" >
                                                            <FaPlus />
                                                            Add File here
                                                        </button>
                                                    </div> */}
                                                    <div className="add-item-empty-div" style={{ alignItems: 'center' }}>
                                                        <div
                                                            className="text-primary"
                                                            style={{
                                                                marginTop: '1px',
                                                                padding: '5px 7px',
                                                                border: '2px solid #9e9e9e',
                                                                borderRadius: '32px',
                                                            }}
                                                        >
                                                            <PlusIcon height="16px" width="16px" />
                                                        </div>
                                                        <div style={{ marginLeft: '10px' }}>
                                                            <div
                                                                className='flex'
                                                                style={{
                                                                    gap: '5px'
                                                                }}
                                                            >
                                                                <span className="fw-500">Drag & Drop or Click to Upload</span>
                                                                <span className="text-gray-700">OR</span>
                                                                <span className="text-blue-600 fw-500">Browse Files</span>
                                                            </div>
                                                            <div className="text-gray-600 fw-400 mt-1 flex align-items-center" style={{ fontSize: '10px', gap: '5px' }}>
                                                                <InfoIcon width='14px' height='14px' />
                                                                <span>
                                                                    png, jpg, jpeg or pdf (Max file size: 5MB)
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <input {...getAttachmentInputProps({ disabled: false })} style={{ display: 'none' }} />{' '}
                                                </div>
                                            )
                                        }
                                        
                                        
                                    </div>
    
                                </div>
                            </div>
                        </div>

                        <div className="row" style={{ marginTop: '15px' }}>
                            <div className="col-12 d-flex justify-right items-center">
                                <button
                                    className="btn btn-primary btn-outlined-main"
                                    type="submit"
                                    disabled={disableStatus}
                                    style={{ marginRight: '10px' }}
                                >
                                    <FaSave /> {editPayment ? 'Update' : 'Save'}
                                </button>
                                <button className="btn btn-primary btn-outlined-main" onClick={handleClose}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default PaymentFormModal;

